import React, { Suspense, useEffect, useState } from 'react'
import { Route, Routes as Switch, useNavigate } from "react-router-dom";
import { Dashboard } from '../pages/Dashboard';
import Layout from './Layout/Layout';
import Categories from '../pages/Category/Categories';
import SubCategories from '../pages/SubCategories/SubCategories';
import CreateMyProfile from '../pages/MyProfile/CreateMyProfile';
import MyProfile from '../pages/MyProfile/MyProfile';
import PromoCodes from '../pages/PromoCodes/PromoCodes';
import { Roles } from '../pages/roles/roles';
import { CreateRole } from '../pages/roles/createRole';
import { Users } from '../pages/users/users';
import { CreateUser } from '../pages/users/createUser';
import Manufacturer from '../pages/Manufacturer/Manufacturer';
import CreateManufacturer from '../pages/Manufacturer/CreateManufacturer';
import Inventory from '../pages/Inventory/Inventory';
import CreateInventory from '../pages/Inventory/CreateInventory';
import SubCategoriesProducts from '../pages/SubCategories/SubCategoriesProducts';
import CreateSubCategoriesProducts from '../pages/SubCategories/CreateSubCategoriesProducts';
import { RecoilRoot } from 'recoil';
import Orders from '../pages/Order/Orders';
import Payment from '../pages/Payments/Payment';
import Support from '../pages/Support/Support';
import OrderDetails from '../pages/Order/OrderDetails';
import Banner from '../pages/Banner/Banner';
import PaymentDetails from '../pages/Payments/PaymentDetails';
import Brand from '../pages/Brand/Brand';
import CreateBrand from '../pages/Brand/CreateBrand';
import ViewNotifications from '../pages/Notifications/viewNotifications';
import ChatSupport from '../pages/chatSupport/chatSupport';
import PageNotFound from '../pages/404/PageNotFound';
import Tracking from '../pages/Tracking/Tracking';
import AdminSettings from '../pages/AdminSettings/AdminSettings';
import SmartInventoryPage from '../pages/Inventory/SmartInventory/SmartInventory';
import SyncInventory from '../pages/Inventory/SmartInventory/syncInventory';
import CreateSubCategory from '../pages/SubCategories/CreateSubCategory';
import ProtectedRoute from './protectedRoutes';
import EditBrandPage from '../pages/Brand/EditBrandPage';

import RegisterManufacturer from '../pages/Manufacturer/RegisterManufacturer';
import PromoCodesPage from '../pages/PromoCodes/PromoCodesPage';
import CreatePromoCodesPage from '../pages/PromoCodes/CreatePromoCodesPage';
import AutoNotification from '../pages/AutoNotifications/AutoNotification';
import AnalyticsDashboard from '../pages/Analytics/AnalyticsDashboard';
import SearchAnalytics from '../pages/Analytics/SearchAnalytics';
import LocationAnalytics from '../pages/Analytics/LocationAnalytics';
import CreateUpdateBannerPage from '../pages/Banner/CreateUpdateBannerPage';

const AdminLayout = () => {

    const navigate = useNavigate();

    useEffect(() => {
        const logged = localStorage.getItem('token');
        const userType = JSON.parse(localStorage.getItem('user'))?.userType;

        const currentPath = window.location.pathname;
        if (!logged && currentPath !== '/register-vendor') {
            navigate('/login')
        } else if (userType === 'customerSupport') {
            navigate('/chat-support')
        }
    }, [])

    return (
        <Suspense
            fallback={
                <div style={{ height: '100vh' }}>
                    Loading
                </div>
            }
        >
            <RecoilRoot>
                <Layout>
                    <Switch>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/categories" element={<Categories />} />
                        <Route path="/sub-categories/:id" element={<SubCategories />} />
                        <Route path="/create-sub-categories/:id" element={<CreateSubCategory />} />
                        <Route path="/create-sub-categories" element={<CreateSubCategory />} />
                        <Route path="/sub-categories-products/:id" element={<SubCategoriesProducts />} />
                        <Route path="/create-sub-categories-products/:id" element={<CreateSubCategoriesProducts />} />
                        <Route path="/create-profile" element={<CreateMyProfile />} />
                        <Route path="/my-profile" element={<MyProfile />} />
                        <Route path="/promocodes" element={<ProtectedRoute adminOnly><PromoCodes /></ProtectedRoute>} />




                        {/* new navigation routes for promocodes */}
                        <Route path="/promocodes-page" element={<ProtectedRoute adminOnly><PromoCodesPage /></ProtectedRoute>} />
                        <Route path="/edit-promocodes/:id" element={<ProtectedRoute adminOnly><CreatePromoCodesPage /></ProtectedRoute>} />

                        
                        <Route path="/create-promocodes" element={<ProtectedRoute adminOnly><CreatePromoCodesPage /></ProtectedRoute>} />

                        <Route path='/orders' element={<Orders />} />
                        <Route path='/orderdetails/:id' element={<OrderDetails />} />

                        <Route path="/tracking" element={<ProtectedRoute adminOnly><Tracking /></ProtectedRoute>} />


                        <Route path='/payments' element={<Payment />} />
                        <Route path='/paymentdetails' element={<PaymentDetails />} />
                        <Route path='/support' element={<Support />} />
                        <Route path='/view-notifications' element={<ViewNotifications />} />

                        <Route path="/banner" element={<ProtectedRoute adminOnly><Banner /></ProtectedRoute>} />
                        <Route path="/create-banner" element={<ProtectedRoute adminOnly><CreateUpdateBannerPage /></ProtectedRoute>} />
                        <Route path="/edit-banner/:id" element={<ProtectedRoute adminOnly><CreateUpdateBannerPage /></ProtectedRoute>} />


                        <Route path="/brand" element={<ProtectedRoute adminOnly><Brand /></ProtectedRoute>} />
                        <Route path="/create-brand" element={<ProtectedRoute adminOnly><CreateBrand /></ProtectedRoute>} />
                        <Route path="/edit-brand-page/:id" element={<ProtectedRoute adminOnly><EditBrandPage /></ProtectedRoute>} />
                        <Route path="/edit-brand-page" element={<ProtectedRoute adminOnly><EditBrandPage /></ProtectedRoute>} />


                        <Route path="/auto-notification" element={<ProtectedRoute adminOnly><AutoNotification /></ProtectedRoute>} />



                        <Route path="/inventory" element={<Inventory />} />
                        <Route path="/create-inventory" element={<CreateInventory />} />
                        <Route path="/sync-inventory" element={<SmartInventoryPage />} />
                        <Route path="/sync-inventory/:id" element={<SmartInventoryPage />} />

                        <Route path="/map-category-size/:id" element={<SyncInventory />} />

                        <Route path="/edit-inventory/:id" element={<CreateInventory />} />


                        <Route path="/vendors" element={<ProtectedRoute adminOnly><Manufacturer /></ProtectedRoute>} />
                        <Route path="/create-vendors" element={<ProtectedRoute adminOnly><CreateManufacturer /></ProtectedRoute>} />
                        <Route path="/edit-vendors/:id" element={<ProtectedRoute ><CreateManufacturer /></ProtectedRoute>} />
                        <Route path="/register-vendor" element={<RegisterManufacturer />} />

                        <Route path="/roles" element={<ProtectedRoute adminOnly><Roles /></ProtectedRoute>} />
                        <Route path="/create-role" element={<ProtectedRoute adminOnly><CreateRole /></ProtectedRoute>} />
                        <Route path="/edit-role/:id" element={<ProtectedRoute adminOnly><CreateRole /></ProtectedRoute>} />

                        <Route path="/users" element={<ProtectedRoute adminOnly><Users /></ProtectedRoute>} />
                        <Route path="/create-user" element={<ProtectedRoute adminOnly><CreateUser /></ProtectedRoute>} />
                        <Route path="/edit-user/:id" element={<ProtectedRoute adminOnly><CreateUser /></ProtectedRoute>} />

                        <Route path="/analytics-dashboard" element={<ProtectedRoute adminOnly><AnalyticsDashboard /></ProtectedRoute>} />
                        <Route path="/search-analytics" element={<ProtectedRoute adminOnly><SearchAnalytics /></ProtectedRoute>} />
                        <Route path="/location-analytics" element={<ProtectedRoute adminOnly><LocationAnalytics /></ProtectedRoute>} />
        
                        <Route path="/chat-support" element={<ChatSupport />} />

                        <Route path="/admin-settings" element={<ProtectedRoute adminOnly><AdminSettings /></ProtectedRoute>} />

                        <Route path="*" element={<PageNotFound />} />

                    </Switch>
                </Layout>
            </RecoilRoot>
        </Suspense>
    )
}

export default AdminLayout
